/**
 * Canonical app role for RBAC / nav / My Tasks behavior.
 * Some flows still store or send "qa" instead of "tester".
 */
export function normalizeAppRole(role) {
  const r = String(role || '').toLowerCase().trim();
  if (r === 'qa') return 'tester';
  return r;
}

export function isQaTesterRole(role) {
  return normalizeAppRole(role) === 'tester';
}
